export default "__VITE_ASSET__DS2Ex3GU__"